import { InjectionToken } from '@angular/core';
import { ApiConstant } from '../types';

export const API_TOKEN = new InjectionToken<ApiConstant>('api.constant');
export type SimulationDialog = {
    simulation: SimulationData;
    organizations: any
}
export interface SimulationData {
    id: number;
    name: string | null;
    status: string | null;
    joinedParticipent: number | null;
    startDate: number | null;
    startTime: string | null;
    endDate: number | null;
    organizationId: string | null;
    simulationTypeId: string | null;
    simulationTypeName: string | null;
    roomNumber: string | null;
    participantLogAvailable: number | null;
    loginCode: string | null;
    link: string | null;
    acceptJoinViaLink: boolean | null;
    allowJoinAfterSimulationStarts?: boolean | null;
    startVideoRecording?: boolean | null;
    invitePeople: string | null;
    allowParticipents: string | null;
    feedBackHistories: string | null;
    isRec?: boolean;
}

export interface CreateOrUpdateSimulations {
    simulationId: number;
    actionType: string;
    //tạm
    createdBy?: string;
    detailsRequest: DetailsRequest;
    settingsRequest: SettingsRequest;
}

export interface DetailsRequest {
    name?: string | null;
    startDate?: number | null;
    startTime?: string | null;
    organizationId?: string | null;
    simulationTypeId?: string | null;
    roomNumber?: string | null;
    participantLogAvailable?: number | null;
}

export interface SettingsRequest {
    loginCode: string | null;
    link: string | null;
    acceptJoinViaLink: boolean | null;
    invitePeople: invitePeopleInterface[] | null;
    allowJoinAfterSimulationStarts?: boolean | null;
    startVideoRecording?: boolean | null;
    resendEmail?: boolean;
}

export interface invitePeopleInterface {
    name: string;
    avatar: string;
    email: string;
}

export interface FilterSimulation {
    organizationId: string;
    pageSize: number;
    pageIndex: number;
}
export enum SIMULATION_STATUS {
    NOT_STARTED = '1',
    RUNNING = '2',
    ENDED = '3',
}

export enum SIMULATION_ACTION {
    CREATE = 'create',
    UPDATE = 'update',
    START = 'start',
}
